import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { stJosephMIConfig } from "./data";

export default function StJosephMIPage() {
  return <CityPageTemplate config={stJosephMIConfig} />;
}